import * as _ from 'lodash';

//  define data

export interface IPowerSource
{
    id: string;
    'group-id'?: string;
    label?: string;
    'cost-per-mw'?: number;
    'energy-output'?: number;
    'energy-multipliers'?: number[];
    'environmental-impact'?: number;
    requirements?: string[];
    max?: number;
    'requirement-reason'?: string;
    description?: string;
    include?: boolean;
    removable?: boolean;
    vo: string;
}

export interface IPowerSourceLocation
{
    position: number[];
    type: string;
    vo: string;
}


export interface IEnergyMixDictionary
{
    [power_source_id: string]: number
}

export interface ISeason
{
    id: string;
    title: string;
    'energy-demand': number;
    description: string;
}

export interface IMiniGame
{
    id: string;
    category: string;
    type: string;
    title: string;
    description: string;
    'results-text': string;
    results: string[];
    vo: string;
}

export interface IHint
{
    id: string;
    hints: string[];
    // title: string;
    // image: string;
    // description: string;
    // vo: string;
    // requirements: { [kpi: string]: number[] }
}

export interface IOutage
{
    id: string;
    title: string;
    image: string;
    description: string;
    affects: string[];
    vo: string;
}

export interface IQuestion
{
    id: string;
    image: string;
    question: string;
    answers: IAnswer[];
    answer: number;
    response: string;
    vo: string;
}

export interface IAnswer
{
    text: string;
    vo: string;
}

export interface IContentItem
{
    [id: string]: string;
    vo: string;
}


export interface IYear
{
    year: number;
    headline: string;
    description: string;
    'year-end'?: string;
    'year-end-success'?: string;
    'year-end-fail'?: string;
    reminder: string;
    demand: number;
    time?: number;
    'carbon-target': number;
    'add-sources': number;
    remove: string;
    outage: string;
    deprecate: string;
    'mini-game': string;
    'map-state': string;
    ignore?: { [id: string]: boolean };
}


export interface AppData
{
    'power-sources': IPowerSource[];
    'power-source-locations': IPowerSourceLocation[];
    'default-power-sources': string[];
    years: IYear[];
    'seasons': ISeason[];
    'energy-mix': IEnergyMixDictionary;
    'hints': IHint[];
    'outages': IOutage[];
    'mini-games': IMiniGame[];
    'questions': IQuestion[];
}

//  import data

const data: AppData = require('../../data/power-map.yaml');


/**
 * get the list of power sources
 * @returns {any}
 */
export function getAllPowerSourcesData() : IPowerSource[]
{
    return data['power-sources'];
}

/**
 * get the list of power sources
 * @returns {any}
 */
export function getPowerSourcesData() : IPowerSource[]
{
    const power_sources: IPowerSource[] = data['power-sources'];

    return _.filter(power_sources, power_source => power_source.include !== false);
}


/**
 * get a power source data item by id
 * @returns {any}
 */
export function getPowerSourceDataByID(power_source_id: string) : IPowerSource
{
    const power_sources: IPowerSource[] = data['power-sources'];

    return _.find(power_sources, ['id', power_source_id]);
}


/**
 * get the list of power source locations
 * @returns {any}
 */
export function getPowerSourceLocationsData() : IPowerSourceLocation[]
{
    return data['power-source-locations'];
}


/**
 * get the list of default power sources to place on the map at the game's start
 * @returns {any}
 */
export function getDefaultPowerSourcesData() : IPowerSource[]
{
    const default_sources: string[] = data['default-power-sources'];
    const power_sources: IPowerSource[] = getAllPowerSourcesData();

    return _.map(default_sources, (source_id: string, position_id: number) =>
    {
        return _.find(power_sources, { id: source_id });
    })
}


/**
 * get the list of year data
 * @returns {any}
 */
export function getYearsData() : IYear[]
{
    return data['years'];
}


/**
 * get the list of power source locations
 * @returns {any}
 */
export function getSeasonsData() : ISeason[]
{
    return data['seasons'];
}


/**
 * get the required energy mix data
 * @returns {any}
 */
export function getEnergyMixData() : IEnergyMixDictionary
{
    return data['energy-mix'];
}


/**
 * get a single power source location
 * @returns {any}
 */
export function getPowerSourceLocationData(location_id: number) : IPowerSourceLocation
{
    return getPowerSourceLocationsData()[location_id];
}


/**
 * get the list of outages
 * @returns {any}
 */
export function getOutages() : IOutage[]
{
    return data['outages'];
}


/**
 * get the list of game events
 * @returns {any}
 */
export function getHints() : IHint[]
{
    return data['hints'];
}


/**
 * get the list of game events
 * @returns {any}
 */
export function getMiniGames() : IMiniGame[]
{
    return data['mini-games'];
}


/**
 * get the list of questions
 * @returns {any}
 */
export function getQuestions() : IQuestion[]
{
    return data['questions'];
}


/**
 * get the list of content items
 * @returns {any}
 */
export function getContent(id: string) : IContentItem
{
    return data['content'][id];
}


export function getGameOverHint(area_id: string, score: number) : string
{
    return data['game-over-hints'][area_id][score];
}


export interface GameOverResult
{
    energy: number[];
    carbon: number[];
    wind?: number;
    text: string;
}


export function getGameOverResults() : GameOverResult[]
{
    return data['game-over-results'];
}


export interface QuestionResult
{
    correct: number;
    text: string
}


export function getQuestionResults() : QuestionResult[]
{
    return data['question-results'];
}



// WEBPACK FOOTER //
// ./src/ts/data/data.ts